import Cookies from "js-cookie"

export const set = Cookies.set
export const get = Cookies.get
export const remove = Cookies.remove
